"use strict";

import Common from "../../Common";
import CommonGame from "../../CommonGame";
import ConfirmationPanel from "./ConfirmationPanel";
import TrashConfirmationPanel from "./TrashConfirmationPanel";

export default class MenuPanel extends PIXI.Container {
    constructor(signals) {
        super();

        this._gameSceneSignals = signals;

        // Attributes.
        this._quitBtn = null;
        this._backBtn = null;
        this._printBtn = null;
        this._downloadBtn = null;
        this._muteBtn = null;
        this._binBtn = null;
        this._boxBorderSprite = null;
        this._popupContainer = null;
        this._drawingActionContainer = null;
        this._titleSprite = null;
        this._bgGradientSprite = null;
        this._titleText = null;
        this._confirmationPanel = null;
        this._trashConfirmationPanel = null;
    }

    init() {
        // Bg gradient sprite.
        this._bgGradientSprite = new PIXI.Sprite(Common.blankTexture);
        this._bgGradientSprite.tint = 0x000000;
        this._bgGradientSprite.alpha = 0.6;
        this._bgGradientSprite.anchor = new PIXI.Point(0.5, 0.5);
        this._bgGradientSprite.scale.x = Common.STAGE_WIDTH * 1.25;
        this._bgGradientSprite.scale.y = Common.STAGE_HEIGHT;
        this._bgGradientSprite.interactive = true;
        this._bgGradientSprite.click = this._bgGradientSprite.touchend = this._onBackButton_Click.bind(this);
        this.addChild(this._bgGradientSprite);

        // Popup.
        this._popupContainer = new PIXI.Container();
        this._popupContainer.anchor = new PIXI.Point(0.5, 0.5);
        this.addChild(this._popupContainer);

        // Bg.
        /*
         //removed due to feedback
         //@deprecated
         var SCALE_FACTOR = 0.985;
         var popupTex = Common.assets.getTexture("popup_box");

         var popupBg = new PIXI.Graphics();
         popupBg.beginFill(CommonGame.GALLERY_BORDER_TINT[CommonGame.selectedGallery], 1);
         popupBg.drawRoundedRect(
         -popupTex.width * 0.5 * SCALE_FACTOR,
         -popupTex.height * 0.5 * SCALE_FACTOR,
         popupTex.width * SCALE_FACTOR,
         popupTex.height * SCALE_FACTOR,
         35
         );
         popupBg.endFill();
         popupBg.interactive = true;
         this._popupContainer.addChild(popupBg);
         */

        // Border.
        this._boxBorderSprite = new PIXI.Sprite(Common.assets.getTexture("menu_panel"));
        this._boxBorderSprite.anchor = new PIXI.Point(0.5, 0.5);
        this._popupContainer.addChild(this._boxBorderSprite);
        this._popupContainer.scale.set(0.9, 0.9);

        // Title sprite.
        this._titleSprite = new PIXI.Sprite(PIXI.Texture.EMPTY);
        this._titleSprite.anchor = new PIXI.Point(0.5, 0.5);

        this._popupContainer.addChild(this._titleSprite);

        // Title text.
        let bkText = P3.createText("MENU", {
            fill: [0xfff8b3, 0xfac109],
            size: "90px",
            wordWrap: true,
            wordWrapWidth: 500,
            stroke: 0x23a838,
            strokeThickness: 14,
            align: "centre"
        });

        this._titleText = P3.createText("MENU", {
            fill: [0xfff8b3, 0xfac109],
            size: "90px",
            wordWrap: true,
            wordWrapWidth: 500,
            stroke: 0x006130,
            align: "centre",
            strokeThickness: 8
        });

        this._titleText.y = bkText.y = -this._boxBorderSprite.height * 0.5 + 145;
        this._titleText.anchor = bkText.anchor = new PIXI.Point(0.5, 0.5);
        this._titleSprite.addChild(bkText, this._titleText);

        // Quit button.
        this._quitBtn = createButton("home");
        this._quitBtn.anchor = new PIXI.Point(0.5, 0.5);
        this._quitBtn.position = new PIXI.Point(-234, 248);
        this._quitBtn.overSoundName = "sfx_ui_rollover_00";
        this._quitBtn.downSoundName = "sfx_ui_click_00";
        this._quitBtn.signals.click.add(this._onQuitButton_Click, this);
        this._popupContainer.addChild(this._quitBtn);

        // Sound button.
        this._muteBtn = createButton("sound");
        this._muteBtn.anchor = new PIXI.Point(0.5, 0.5);
        this._muteBtn.position = new PIXI.Point(238, 248);
        this._muteBtn.overSoundName = "sfx_ui_rollover_00";
        this._muteBtn.downSoundName = "sfx_ui_click_00";
        this._muteBtn.signals.click.add(this._onSoundButton_Click, this);
        this._popupContainer.addChild(this._muteBtn);

        // Container for Print, Download and Bin buttons.
        this._drawingActionContainer = new PIXI.Sprite(PIXI.Texture.EMPTY);
        this._drawingActionContainer.anchor.set(0.5, 0.5);
        this._drawingActionContainer.y = -15;
        this._popupContainer.addChild(this._drawingActionContainer);

        const btnOffset = 240;
        let btnStatesAux;

        // Print button.
        if (Common.assets.getJSON("config").menuPanel.printBtn.isVisible) {
            btnStatesAux = new P3.ButtonStates(
                PIXI.Texture.EMPTY,
                PIXI.Texture.EMPTY,
                PIXI.Texture.EMPTY,
                Common.assets.getTexture("icon_print")
            );
            this._printBtn = new P3.Button(btnStatesAux);
            this._printBtn.anchor = new PIXI.Point(0.5, 0.5);
            this._printBtn.x = -btnOffset;

            this._printBtn.signals.click.add(this._onPrintButton_Click, this);
            this._drawingActionContainer.addChild(this._printBtn);
        }

        // Download button.
        if (Common.assets.getJSON("config").menuPanel.downloadBtn.isVisible) {
            btnStatesAux = new P3.ButtonStates(
                PIXI.Texture.EMPTY,
                PIXI.Texture.EMPTY,
                PIXI.Texture.EMPTY,
                Common.assets.getTexture("icon_save"));
            this._downloadBtn = new P3.Button(btnStatesAux);
            this._downloadBtn.anchor = new PIXI.Point(0.5, 0.5);
            this._downloadBtn.x = 0;//this._drawingActionContainer.children.length * btnOffset;

            this._downloadBtn.signals.click.add(this._onDownloadButton_Click, this);
            this._drawingActionContainer.addChild(this._downloadBtn);
        }

        // Bin button.
        if (Common.assets.getJSON("config").menuPanel.binBtn.isVisible) {
            btnStatesAux = new P3.ButtonStates(
                PIXI.Texture.EMPTY,
                PIXI.Texture.EMPTY,
                PIXI.Texture.EMPTY,
                Common.assets.getTexture("icon_replay"));
            this._binBtn = new P3.Button(btnStatesAux);
            this._binBtn.anchor = new PIXI.Point(0.5, 0.5);
            this._binBtn.x = btnOffset;

            this._binBtn.signals.click.add(this._onBinButton_Click, this);
            this._drawingActionContainer.addChild(this._binBtn);
        }

        // Back button.
        this._backBtn = createButton("play_large", "primary_large");
        this._backBtn.anchor = new PIXI.Point(0.5, 0.5);
        this._backBtn.position = new PIXI.Point(0, this._boxBorderSprite.height * 0.5 - 115);
        this._backBtn.overSoundName = "sfx_ui_rollover_00";
        this._backBtn.downSoundName = "sfx_ui_click_00";
        this._backBtn.signals.click.add(this._onBackButton_Click, this);
        this._popupContainer.addChild(this._backBtn);

        // Confirmation panel.
        this._confirmationPanel = new ConfirmationPanel();
        this._confirmationPanel.anchor = new PIXI.Point(0.5, 0.5);
        this._confirmationPanel.init();
        this.addChild(this._confirmationPanel);

        // Trash confirmation panel.
        this._trashConfirmationPanel = new TrashConfirmationPanel();
        this._trashConfirmationPanel.anchor = new PIXI.Point(0.5, 0.5);
        this._trashConfirmationPanel.init();
        this.addChild(this._trashConfirmationPanel);

        this.visible = false;
        this.alpha = 0;
    }

    show() {
        // Animate-in.
        this.visible = true;
        this._popupContainer.y = -50;
        TweenMax.to(this, 0.25, {alpha: 1, ease: Quad.easeOut});
        TweenMax.to(this._popupContainer, 0.25, {y: 0, ease: Quad.easeOut});

        this._backBtn.alpha = 0;
        this._backBtn.scale = new PIXI.Point();
        TweenMax.to(this._backBtn, 0.25, {alpha: 1, ease: Sine.easeOut, delay: 0.2});
        TweenMax.to(this._backBtn.scale, 0.5, {x: 1, y: 1, ease: Elastic.easeOut, delay: 0.2});

        Common.game.scene.addTutorialEvent(CommonGame.TUT_EVENT.MENU_PANEL_SHOWN);
    }

    //----EVENTS----//

    _onQuitButton_Click() {
        this._confirmationPanel.signals.onYes.addOnce(
            () => {
                // Music.
                Common.audio.stopMusic();
                Common.audio.playMusic("music_mainmenu_loop_00");

                // Common.main.application.loadScene(CommonGame.SCENE_ID_IMAGE_SELECTION);
                this._gameSceneSignals.previous.dispatch(this);
            }, this);
        this._confirmationPanel.show(Common.assets.getJSON("languages").LEAVE_CONFIRMATION[Common.language]);
    }

    _onPrintButton_Click() {
        // Sfx.
        Common.audio.playSound("sfx_ui_newpage_00");

        this.visible = false;
        Common.game.hud.visible = false;

        //--timeout is needed. otherwise window.open returns null (according to SO must be initialised by a native event)--//
        setTimeout(()=> {
            var canvas = Common.renderer.extract.canvas(Common.game.canvas);
            var myWindow = window.open();
            if (myWindow) {
                myWindow.document.body.appendChild(canvas);

                var css = "@page { size: landscape; margin-top: 1.4cm; margin-left: 2.3cm; }";
                var head = myWindow.document.head || myWindow.document.getElementsByTagName("head")[0];
                var style = document.createElement("style");

                style.type = "text/css";
                style.media = "print";

                if (style.styleSheet)
                    style.styleSheet.cssText = css;
                else
                    style.appendChild(document.createTextNode(css));

                head.appendChild(style);


                myWindow.print();
                myWindow.close();
            } else {
                console.error("unable to open new window");
                console.log(myWindow);
            }

            this.visible = true;
            Common.game.hud.visible = true;
        }, 2.5);

    }

    _onDownloadButton_Click() {
        // Sfx.
        Common.audio.playSound("sfx_ui_folder_save_00");

        this.visible = false;
        Common.game.hud.visible = false;

        setTimeout(()=> {
            var canvas = Common.renderer.extract.canvas(Common.game.canvas);
            var myWindow = window.open();
            if (myWindow != null)
                myWindow.document.body.appendChild(canvas);

            this.visible = true;
            Common.game.hud.visible = true;
        }, 2.5);
    }

    _onSoundButton_Click() {
        Common.isMute = !Common.isMute;

        // TODO:
        this._muteBtn._icon.texture = Common.assets.getTexture(Common.isMute ? "icon_mute_off" : "icon_sound_off");
        this._muteBtn._currentIconTexture = this._muteBtn._icon.texture;

        Common.audio.mute(Common.isMute);
    }

    _onBinButton_Click() {
        this._trashConfirmationPanel.signals.onYes.addOnce(
            function () {
                // Sfx.
                Common.audio.playSound("sfx_tool_trashcan_select_00");

                Common.game.canvas.clear();
                Common.game.undoManager.clear();

                this.visible = false;
            }, this);
        this._trashConfirmationPanel.show(Common.assets.getJSON("languages").BIN_CONFIRMATION[Common.language]);
    }

    _onBackButton_Click() {
        // Animate-out.
        TweenMax.to(this, 0.25, {alpha: 0, ease: Quad.easeOut});
        TweenMax.to(this._popupContainer, 0.25, {
                y: 50,
                ease: Quad.easeOut,
                onComplete: function () {
                    this.visible = false;
                    Common.game.scene.addTutorialEvent(CommonGame.TUT_EVENT.MENU_PANEL_HIDDEN);
                },
                onCompleteScope: this
            }
        );
    }
}